import { ROUTER_API } from 'app/constants/api.constant';
import BaseApi from 'app/services/api/base.api';
import {
  AuthOrderDTO,
  AuthOrderResponseDTO,
  PendingUserDTO,
  PendingUserResponseDTO,
  TagModelDTO,
  TagScanResponse,
} from '../../tablet/types';

export const tabletApi = new BaseApi({
  baseURL: `${ROUTER_API}/api/v2`,
  tokenKey: 'token',
  timeout: 30000,
});

export const tabletProvider = new BaseApi({
  baseURL: `${ROUTER_API}/providers/core/v1`,
  tokenKey: 'token',
  timeout: 30000,
});

export const getTagInformationApi = async (tagId: string) => {
  const url = `/tags/uid/${tagId}`;
  const { data } = await tabletApi.api.get<TagModelDTO>(url);
  return data;
};

export const postTagScan = async (tagId: string, userId: string) => {
  const url = '/tags/tablet/scan';
  return tabletApi.api.post<TagScanResponse>(url, {
    tag_id: tagId,
    user_id: userId,
  });
};

export const saveOrderApi = async (payload: AuthOrderDTO) => {
  const url = '/auth/order';
  const { data } = await tabletProvider.api.post<AuthOrderResponseDTO>(url, payload);
  return data;
};

export const createPendingUserApi = async (payload: PendingUserDTO) => {
  const url = '/pending-users';
  const { data } = await tabletApi.api.post<PendingUserResponseDTO>(url, payload);
  return data;
};
